import { Pipe, PipeTransform } from '@angular/core';
import { LocService } from '../../shared-context/loc.service';

@Pipe({
    name: 'localDataSize'
})
export class LocalDataSizePipe implements PipeTransform {
    constructor(private readonly locService: LocService) {
    }

    public transform(sizeInBytes: number) {
        return this.formatDataSize(sizeInBytes);
    }

    /**
    * Formats a data size in bytes into localized string with appropriate units
    * A decimal (not zero) will only be added for final values < 10
    * Ex. 125 => 125 B
    * Ex. 1024 => 1 KB
    * Ex. 1540000 => 1.5 MB
    */
    private formatDataSize(sizeInBytes: number): string {
        let scale = 4;
        let dataSize = 0;
        while (dataSize < 1 && scale >= 0) {
            dataSize = sizeInBytes / 1024 ** scale;
            scale--;
        }
        const divider = dataSize < 10 && dataSize % 1 >= 0.1 ? 10 : 1;
        dataSize = Math.round(dataSize * divider) / divider;
        const displayNum = this.locService.localizedNumberString(dataSize);
        let displayUnit = '';
        switch (scale) {
            case 3:
                displayUnit = this.locService.Terabytes;
                break;
            case 2:
                displayUnit = this.locService.Gigabytes;
                break;
            case 1:
                displayUnit = this.locService.Megabytes;
                break;
            case 0:
                displayUnit = this.locService.Kilobytes;
                break;
            case -1:
                displayUnit = this.locService.Bytes;
                break;
        }
        return `${displayNum} ${displayUnit}`;
    }
}
